@if (!paletteAendern) {
  <div class="font-bold text-sm text-primary-400 mb-1">
    {{'#LLR_KOMMISSIONIERUNG.ARTIKEL_HEADER.TITEL_ARTIKEL' | translate}}
  </div>
  <div class="soft-card rounded-sm flex flex-row w-full items-center justify-between select-none mb-4 !p-3">
    <div class="flex flex-row w-full justify-between">
      <div class="flex flex-col w-3/5 gap-2">
        <div class="flex flex-row w-full">
          <div class="text-sm text-light">
            {{bewegung?.bewebs?.artikel?.artikelnummer}}
          </div>
        </div>
        <div class="flex flex-row w-full">
          <div class="font-semibold">
            {{bewegung?.bewebs?.artikel?.artbez1}}
          </div>
        </div>
        <div class="flex flex-row w-full">
          <div class="text-sm text-light">
            {{bewegung?.bewebs?.artikel?.artbez2}}
          </div>
        </div>
      </div>
      <div class="flex flex-row w-2/5 self-center justify-end">
        <div class="flex flex-col gap-2 justify-center items-end">
          <div class="font-semibold">
            {{'#LLR_KOMMISSIONIERUNG.ARTIKEL_HEADER.LABEL_GESAMT' | translate}}
            {{$safeNavigationMigration(bewegung?.kommissionierDaten?.offene_menge) | number: '.0-3' }}
            {{bewegung?.kommissionierDaten?.arteh?.arteh}}
          </div>
          @if (!paletteEinzelEingabe &&
            (bewegung?.kommissionierDaten?.arteh?.arteh !== bewegung?.kommissionierDaten?.arteh_palette?.arteh) &&
            (bewegung?.kommissionierDaten?.menge_pro_palette ?? 0 > 0)
            ) {
            <div
              class="font-semibold">
              = {{bewegung?.kommissionierDaten?.anz_paletten ?? 0}} {{bewegung?.kommissionierDaten?.arteh_palette?.arteh ?? 'Pal'}}
            </div>
            <div
              class="font-semibold">
              {{bewegung?.kommissionierDaten?.rest_menge ?? 0}} {{bewegung?.kommissionierDaten?.arteh?.arteh ?? ''}}
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
@if (palette) {
  <div class="font-bold text-sm text-primary-400 mb-1">
    {{'#LLR_KOMMISSIONIERUNG.ARTIKEL_HEADER.TITEL_PALETTE' | translate}}
  </div>
  <div
    class="soft-card rounded-sm flex flex-row w-full items-center justify-between select-none mb-3 !p-3"
    [ngClass]="{'border border-solid border-primary': paletteAendern}">
    <div class="flex flex-row w-full justify-between">
      <div class="flex flex-col w-full gap-2">
        <div class="flex flex-row w-full">
          <div class="text-sm text-light">
            {{ palette?.ssccnummer }}
          </div>
        </div>
        <div class="flex flex-row w-full font-semibold justify-between">
          <div>
            {{palette.palettearten[0]?.charge?.charge ?? 'Charge Placeholder'}}
          </div>
          <div>
            {{palette.palettearten[0]?.menge_offen ?? 0}} {{palette.palettearten[0]?.arteh?.arteh ?? ''}}
          </div>
        </div>
        <div class="flex flex-row w-full">
          <div class="text-sm text-light">
            {{palette?.lagerplatz?.lagerplatz ?? 'Lagerplatz Placeholder'}}
          </div>
        </div>
      </div>
    </div>
  </div>
}

